<template>
    <div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '400px' }" :modal="true">
            <ProgressBar :value="valueProgres" />
            <span>{{ loadingMensaje }}</span>
            <div v-if="timbrando">
                <Button icon="mdi mdi-close" class="p-button-rounded  p-button-text mr-4" @click="cierraVentana()" v-tooltip.bottom="'Cerrar'" style="color:#FB4130"/>
                <Button icon="mdi mdi-download" class="p-button-rounded p-button-text" @click="exportarReporte()" v-tooltip.bottom="'Descargar Reporte'" style="color:#38BD4B"/>
                <div >Seleccione una opción o presione la tecla ESC</div>
            </div>
        </Dialog>
        <!-- DIALOG DEL PDF -->
        <Dialog :visible.sync="dialogPdf" :style="{ width: '850px' }" :closable="false" :modal="true" position="top">
            <comprobante-pdf @cierraDialogPdf="closeDialogPdf"></comprobante-pdf>
        </Dialog>
        <!-- DIALOG DEL CORREO -->
        <Dialog :visible.sync="dialogCorreo" :style="{ width: '1000px' }" :closable="false" :modal="false">
            <Card>
                <template #header>
                    <div class="flex justify-content-between flex-wrap pb-2">
                        <Button @click="CloseDialogCorreo"> Cerrar</Button>
                        {{textoCorreo}}
                        <Button @click="EnviaCorreo" v-if="!masivo"> Enviar</Button>
                        <Button @click="EnviaCorreoMasivo" v-if="masivo"> Envío Masivo</Button>
                    </div>
                </template>
                <template #content>
                    <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                        <div class="field col-12">
                            <span class="p-float-label">
                                <InputText v-model="correo.asunto" type="text" autofocus tabindex="1" />
                                <label>Asunto</label>
                            </span>
                        </div>
                    </div>
                    <Editor v-model="correo.mensaje" editorStyle="height: 200px" />
                </template>
            </Card>
        </Dialog>

        <div class="card">
            <div class="flex card-container blue-container overflow-hidden">
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="mdi mdi-close" class="p-button-rounded p-button-danger p-button-text" @click="cierraVentana()" v-tooltip.bottom="'Cerrar'"/>
                </div>
                <h1 class="flex-grow-1 flex align-items-center justify-content-center py-2">Nómina</h1>
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="mdi mdi-bell-check" class="p-button-rounded p-button-success p-button-text" @click="PostTimbrado()" v-tooltip.bottom="'Timbrar'"/>
                    <Button icon="mdi mdi-download" class="p-button-rounded p-button-success p-button-text" @click="DownloadSeleccionados()" v-tooltip.bottom="'Descargar seleccionados'"/>
                    <Button icon="mdi mdi-send" class="p-button-rounded p-button-success p-button-text" @click="OpenDialogCorreoM()" v-tooltip.bottom="'Enviar seleccionados por correo'"/>
                    <!-- <Button icon="mdi mdi-whatsapp" class="p-button-rounded p-button-success p-button-text" @click="PruebaWA()" v-tooltip.bottom="'Enviar seleccionados por WA'"/> -->
                </div>
            </div>
            <hr size=7 color="#ED6421">
        </div>
        <br>
        <div class="card">
            <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                <!-- DESCRIPCION -->
                <div class="field col-12">
                    <span class="p-float-label">
                        <InputText v-model="nomina.descripcion" type="text"/>
                        <label>Descripción</label>
                    </span>
                </div>
                <!-- NO NOMINA -->
                <div class="field col-2">
                    <span class="p-float-label">
                        <InputText v-model="nomina.noNomina" type="text"/>
                        <label>No. Nómina</label>
                    </span>
                </div>
                <!-- TIPO DE NOMINA -->
                <div class="field col-4">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="nomina.tipoNomina" :options="tipoNomina" optionLabel="tipoNomina" />
                        <label>Tipo de Nómina</label>
                    </span>
                </div>
                <!-- PERIODICIDAD DE PAGO -->
                <div class="field col-4">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="nomina.periodicidadPago" :options="periodicidadPago" optionLabel="periodicidadPago" />
                        <label>Periodicidad de Pago</label>
                    </span>
                </div>
                <!-- SERIE -->
                <div class="field col-2">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="nomina.serie" :options="serie" :editable="true" />
                        <label>Serie</label>
                    </span>
                </div>
                <!-- FECHA DE PAGO -->
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <Calendar v-model="nomina.fechaPago" dateFormat="dd-MM-yy" />
                        <label>Fecha de Pago</label>
                    </span>
                </div>
                <!-- FECHA INICIAL -->
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <Calendar v-model="nomina.fechaInicialPago" dateFormat="dd-MM-yy" />
                        <label>Fecha Inicial</label>
                    </span>
                </div>
                <!-- FECHA FINAL -->
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <Calendar v-model="nomina.fechaFinalPago" dateFormat="dd-MM-yy" />
                        <label>Fecha Final</label>
                    </span>
                </div>
            </div>
            <div class="flex justify-content-center flex-wrap card-container">
                <Chip :label="sumPercepciones" class="mr-2" style="background:#38BD4B"/>
                <Chip :label="sumDeducciones" class="mr-2" style="background:#FB4130"/>
                <Chip :label="sumOtrosPagos" class="mr-2" style="background:#DB9700"/>
                <Chip :label="sumNeto" />
            </div>
            <br>
            <div class="flex justify-content-center flex-wrap card-container">
                <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText v-model="filtros['global'].value" placeholder="Buscar" />
                </span>
            </div>
            <DataTable :value="listNomina" responsiveLayout="scroll" :scrollable="true" scrollHeight="500px" scrollDirection="both" :selection.sync="selectedListNomina" selectionMode="multiple" dataKey="rfc" :metaKeySelection="false" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" :filters.sync="filtros">
                <Column header="Acciones" :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'min-width': '10rem' }" frozen>
                    <template #body="slotProps">
                        <div v-if="slotProps.data.folioFiscal === ''">
                            <Button icon="pi pi-exclamation-circle" class="p-button-rounded p-button-info" v-tooltip.bottom="'Sin Timbrar'" />
                        </div>

                        <div v-if="slotProps.data.folioFiscal != ''">
                            <Button icon="pi pi-check" class="p-button-rounded p-button-success" v-tooltip.bottom="'Timbardo'" />
                            <Button icon="pi pi-file-pdf" class="p-button-rounded p-button-success" v-tooltip.bottom="'PDF'" @click="VerPdfKit(slotProps.data, 'SI')"/>
                            <Button icon="pi pi-download" class="p-button-rounded p-button-warning" v-tooltip.bottom="'Descargar'" @click="VerPdfKit(slotProps.data, 'ZIP')"/>
                            <Button icon="pi pi-send" class="p-button-rounded p-button-warning" v-tooltip.bottom="'Enviar'" @click="OpenDialogCorreo(slotProps.data)"/>
                        </div>
                    </template>
                </Column>
                <Column field="nomina.receptor.numEmpleado" sortable header="Num. Empleado" :styles="{'flex-grow':'1', 'flex-basis':'100px'}"></Column>
                <Column field="nombre" sortable header="Nombre" :styles="{'flex-grow':'1', 'flex-basis':'300px'}"></Column>
                <Column field="rfc" sortable header="RFC" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="nomina.receptor.curp" sortable header="CURP" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="nomina.receptor.puesto" sortable header="Puesto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="nomina.receptor.departamento" sortable header="Departamento" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="nomina.totalPercepciones" sortable header="Total Percepciones" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.nomina.totalPercepciones) }}</span>
                      </template>
                </Column>
                <Column field="nomina.totalDeducciones" sortable header="Total Deducciones" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.nomina.totalDeducciones) }}</span>
                      </template>
                </Column>
                <Column field="nomina.totalOtrosPagos" sortable header="Total Otros Pagos" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.nomina.totalOtrosPagos) }}</span>
                      </template>
                </Column>
                <Column header="Neto Pagado" sortable :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.nomina.netoPagado) }}</span>
                      </template>
                </Column>
                <Column field="folioFiscal" sortable header="Folio Fiscal" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
            </DataTable>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import ComprobantePdf from "../../Pdf/PdfNomina.vue";
    import jsPDF from 'jspdf';
    import JSZip from 'jszip';
    import autoTable from 'jspdf-autotable'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";


    export default {
        components: {
            ComprobantePdf,
        },
        data() {
            return {
                loading: false,
                loadingMensaje: '',
                dialogPdf: false,
                selectedListNomina: [],
                datosCorreo: '',

                archivoXml: '',
                archivoPdf: '',
                datosTrabajadores: [],

                valueProgres: 0,
                timbrando: false,
                reporteFinal: [],

                filtros: {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                },

                dialogCorreo: false,
                correo:{
                    asunto:'Se envía recibo de nómina correspondiente',
                    mensaje:'Este correo fue generado de manera automática, favor de no responder',
                },
                documentoCorreo: {},
                masivo: false,
                textoCorreo:'',
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            
            nomina(){
                return this.$store.state.nominaGuardada;
            },
            
            listNomina(){
                return this.$store.state.listNominaGuardada;
            },
            
            tipoNomina(){
                return this.$store.state.tipoNominaStore;
            },
            
            serie(){
                let serie_ = [];
                return serie_
            },
            
            periodicidadPago(){
                return this.$store.state.periodicidadPagoStore;
            },
            
            datosEmpresa() {
                return this.$store.state.empresaStore
            },

            sumPercepciones(){
                let tabla = this.listNomina
                let suma = tabla.reduce((acumulador, objeto) => acumulador + objeto.nomina.totalPercepciones, 0);
                let resultado = this.formatCurrency(suma);
                return resultado;
            },

            sumDeducciones(){
                let tabla = this.listNomina
                let suma = tabla.reduce((acumulador, objeto) => acumulador + objeto.nomina.totalDeducciones, 0);
                let resultado = this.formatCurrency(suma);
                return resultado;
            },

            sumOtrosPagos(){
                let tabla = this.listNomina
                let suma = tabla.reduce((acumulador, objeto) => acumulador + objeto.nomina.totalOtrosPagos, 0);
                let resultado = this.formatCurrency(suma);
                return resultado;
            },

            sumNeto(){
                let tabla = this.listNomina
                let suma = tabla.reduce((acumulador, objeto) => acumulador + objeto.nomina.netoPagado, 0);
                let resultado = this.formatCurrency(suma);
                return resultado;
            },
        },
        created() {
            this.Iniciales();
        },
        methods: {
            async Iniciales(){
                this.loading = true;
                await this.GetEmpresa();
                await this.GetTipoNomina();
                await this.GeTPeriodicidadPago();
                await this.GetTrabajadores();
                // await this.GetPercepciones();
                // await this.GetDeducciones(),
                // await this.GetOtrosPagos();
                this.loading = false;
            },

            async GetEmpresa() {
                try {
                    let response = await axios.get('Empresas/GetEmpresa/' + this.token.empresaBase);
                    if (response.data.idEmpresa != 0) {
                        this.$store.state.empresaStore = response.data
                    }
                } catch (error) {
                    console.log(error);
                }
            },

            async GetTipoNomina(){
                try{
                    if(this.$store.state.tipoNominaStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Percepciones...';
                    let respuesta = await axios.get("Nomina/GetTipoNomina/");
                    let x =  respuesta.data
                    this.$store.state.tipoNominaStore = x;
                }catch(error){
                    console.log(error);
                }
            },

            async GeTPeriodicidadPago(){
                try{
                    if(this.$store.state.periodicidadPagoStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Periodicidad de Pago...';
                    let respuesta = await axios.get("Nomina/GetPeriodicidad/");
                    let x =  respuesta.data;
                    this.$store.state.periodicidadPagoStore = x;
                }catch(error){
                    console.log(error);
                }
            },

            async GetTrabajadores(){
                try{
                    this.loadingMensaje = 'Consultando Trabajadores...';
                    let respuesta = await axios.get("Nomina/GetTrabajadoresDatos/"+ this.token.empresaBase);
                    let x =  respuesta.data;
                    this.datosTrabajadores = x;
                }catch(error){
                    console.log(error);
                }
            },

            async GetPercepciones(){
                try{
                    this.loadingMensaje = 'Consultando Percepciones...';
                    let respuesta = await axios.get("Nomina/GetPercepciones/" + this.token.empresaBase);
                    let x =  respuesta.data
                    this.$store.state.percepcionesStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            async GetDeducciones(){
                try{
                    this.loadingMensaje = 'Consultando Deducciones...';
                    let respuesta = await axios.get("Nomina/GetDeducciones/" + this.token.empresaBase);
                    let x =  respuesta.data
                    this.$store.state.deduccionesStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            async GetOtrosPagos(){
                try{
                    this.loadingMensaje = 'Consultando Otros Pagos';
                    let respuesta = await axios.get("Nomina/GetOtroPagos/" + this.token.empresaBase);
                    let x =  respuesta.data
                    this.$store.state.otrosPagosStore = x;
                }catch(error){
                    console.log(error)
                }
            },
                       
            cierraVentana(){
                this.$emit('closeDialogNuevaNomina')
            },

            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

            async PostTimbrado(){
                this.timbrando =  false;
                this.loading = true;
                this.loadingMensaje = 'Timbrando trabajadores'
                let lista =  this.listNomina.filter(x => x.folioFiscal === '');
                let contador = lista.length;
                let division = 100 / contador;
                this.reporteFinal = [];
                
                for(let n of lista){
                    let listaF = [];
                    listaF.push(n)
                    try{
                        //SEPARAMOS LOS RECIBOS QUE AUN NO HAN SIDO TIMBRADOS
    
                        let id = this.nomina.idNomina;
                        let respuesta = await axios.post('Nomina/PostNominaTimbrado/' + this.token.empresaBase + '/' + id, listaF);
                        let x = respuesta.data
                        for(var y of x){
                            let indice = this.listNomina.findIndex(r => r.rfc === y.rfc)
                            if(y.folioFiscal || y.folioFiscal != ''){
                                this.listNomina[indice].folioFiscal = y.folioFiscal
                            }
                        }
                        console.log(respuesta.data)
                        for(let a of respuesta.data){
                            let ObjReporte = {
                                rfc: a.rfc,
                                resultado: a.folioFiscal
                            };
                            if(a.error != ""){
                                ObjReporte.resultado = 'Error ' + a.error
                            }
                            this.reporteFinal.push(ObjReporte);
                        }
                        // this.loading = false
                    }catch(error){
                        console.log(error)
                        // this.loading = false;
                    }

                    this.valueProgres += division
                    listaF = [];
                }
                this.timbrando =  true;
                this.loadingMensaje = 'Proceso completado'
            },

            exportarReporte(){
                let lista = [ ...this.reporteFinal ]
                let nombreArchivo = this.nomina.descripcion + '.txt'
                const contenido = lista.map(objeto => JSON.stringify(objeto)).join('\n');
                const enlaceDescarga = document.createElement('a');
                enlaceDescarga.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(contenido);
                enlaceDescarga.download = nombreArchivo;
                enlaceDescarga.style.display = 'none';
                document.body.appendChild(enlaceDescarga);
                enlaceDescarga.click();
                document.body.removeChild(enlaceDescarga);
            },
        
            VerPdf(item){
                console.log(item);
                this.$store.state.pdfNominaStore = { ...item }
                this.dialogPdf = true;
            },

            async VerPdfKit(item, exporta){
                const color_ = "#" + this.$store.state.empresaStore.colores.color;
                this.loading = true;
                this.loadingMensaje = 'Generando comprobante, espere...'
                // console.log(item)
                var ObjLogo = this.datosEmpresa.logo.base64
                let ObjNom = { ...item }
                
                const doc = new jsPDF();
                var pageSize = {
                    width: 595.28,
                    height: 841.89
                };

                // Define los márgenes de la página (en este caso, 10mm)
                var pageMargins = {
                    top: 10,
                    bottom: 10,
                    left: 10,
                    right: 10
                };

                // CABECERA
                let nombreEmisor = doc.splitTextToSize(ObjNom.empresa.nombre, 150)
                let nombreEmisorHeight = doc.getTextDimensions(nombreEmisor).h;
                let yCabecera = 15
                doc.setFontSize(14);
                doc.addImage(ObjLogo, 'PNG', 10, 5, 65, 25);
                doc.setFont('helvetica', 'bold');
                doc.text('Recibo de Nómina ' + ObjNom.serie + ' ' +ObjNom.folio , 200, yCabecera, { align: 'right', font: 'helvetica bold' } );
                doc.setFont('helvetica', 'normal');
                doc.text(ObjNom.empresa.rfc , 200, yCabecera += 5,  { align: 'right' } );
                // doc.text(ObjNom.empresa.nombre , 200, 25, { align: 'right' } );
                doc.text(nombreEmisor , 200, yCabecera +=5, { align: 'right' } );
                doc.setFontSize(10);
                doc.text(ObjNom.empresa.regimenFiscal.regimenFiscal , 200, yCabecera += nombreEmisorHeight, { align: 'right' } );
                doc.text(ObjNom.empresa.domicilioFiscal , 200, yCabecera += 5, { align: 'right' } );
                doc.text(this.formatDate(ObjNom.fecha) , 200, yCabecera += 5, { align: 'right' } );

                //DATOS DEL TRABAJADOR
                yCabecera+=2
                let ObjTrabajador = { ...ObjNom.nomina.receptor  }
                let xTrabajadore = 10;
                let yTrabajador = yCabecera;
                let width = 115;
                let height = 5;
                let cornerRadius = 2;
                let color = [64,125,250]
                let tipoRegimen = doc.splitTextToSize(ObjTrabajador.tipoRegimen.tipoRegimen, 80)
                let tipoRegimenHeight = doc.getTextDimensions(tipoRegimen).h;

                doc.setFillColor(color_);
                doc.setDrawColor(color_);
                doc.roundedRect(xTrabajadore, yTrabajador, width, height, cornerRadius, cornerRadius, 'FD');
                //NOMBRE DEL TRABAJADOR
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.setTextColor(255, 255, 255); // Blanco
                doc.text(ObjTrabajador.numEmpleado + ' | ' + ObjNom.nombre , 60, yTrabajador + 4, { align: 'center' } );

                //TEXTOS
                doc.setFontSize(9);
                yTrabajador +=6;
                let yyTrabajador = yTrabajador
                doc.setTextColor(0, 0, 0);
                doc.text('RFC:' , xTrabajadore, yTrabajador += 4 );
                doc.text('CURP:' , xTrabajadore, yTrabajador += 4 );
                doc.text('Tipo Contrato:' , xTrabajadore, yTrabajador += 4 );
                doc.text('Tipo Régimen:' , xTrabajadore, yTrabajador += 4 );
                yTrabajador += tipoRegimenHeight
                doc.text('Periodicidad:' , xTrabajadore, yTrabajador );
                doc.text('Clave Ent Fed:' , xTrabajadore, yTrabajador += 4 );
                if(ObjTrabajador.tipoRegimen.clave === '02'){
                    doc.text('NSS:' , xTrabajadore, yTrabajador += 4 );
                    doc.text('Fecha Inicio Rel. Lab:' , xTrabajadore, yTrabajador += 4 );
                    doc.text('Antigüedad:' , xTrabajadore, yTrabajador += 4 );
                    doc.text('Riesgo Puesto:' , xTrabajadore, yTrabajador += 4 );
                    doc.text('Departamento:' ,xTrabajadore, yTrabajador += 4 );
                    doc.text('Puesto:' ,xTrabajadore, yTrabajador += 4 );
                }
                doc.text('Domicilio Fiscal:' ,xTrabajadore, yTrabajador += 4 );

                //DATOS
                let xDatos = 45
                doc.setFont('helvetica', 'normal');
                doc.text(ObjNom.rfc, xDatos, yyTrabajador += 4 );
                doc.text(ObjTrabajador.curp, xDatos, yyTrabajador += 4 );
                doc.text(ObjTrabajador.tipoContrato.tipoContrato, xDatos, yyTrabajador += 4 );
                doc.text(tipoRegimen, xDatos, yyTrabajador += 4 );
                yyTrabajador += tipoRegimenHeight;
                doc.text(ObjTrabajador.periodicidadPago.periodicidadPago, xDatos, yyTrabajador );
                doc.text(ObjTrabajador.claveEntFed.claveEntFed, xDatos, yyTrabajador += 4 );
                if(ObjTrabajador.tipoRegimen.clave === '02'){
                    doc.text(ObjTrabajador.numSeguridadSocial, xDatos, yyTrabajador += 4 );
                    doc.text(this.formatDate(ObjTrabajador.fechaInicioRelLaboral), xDatos, yyTrabajador += 4 );
                    doc.text(ObjTrabajador.antiguedad, xDatos, yyTrabajador += 4 );
                    doc.text(ObjTrabajador.riesgoPuesto.riesgoPuesto, xDatos, yyTrabajador += 4 );
                    doc.text(ObjTrabajador.departamento, xDatos, yyTrabajador += 4 );
                    doc.text(ObjTrabajador.puesto, xDatos, yyTrabajador += 4 );
                }
                doc.text(ObjNom.cliente.domicilioFiscal, xDatos, yyTrabajador += 4 );

                //DATOS DEL PAGO
                let yPagos = yCabecera
                let xPagos = 130;
                let yyPagos = 0;
                let xxPagos = 165;

                doc.setFillColor(color_);
                doc.setDrawColor(color_);
                doc.roundedRect(130, yPagos, 70, 5, 2, 2, 'FD');
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.setTextColor(255, 255, 255); // Blanco
                doc.text('PAGOS' , 165, yPagos += 4, { align: 'center' } );
                yyPagos = yPagos;
                doc.setFontSize(9);
                doc.setTextColor(0, 0, 0);
                doc.text('Tipo de Nómina:' , xPagos, yPagos += 6 );
                doc.text('Fecha Inicial: :' , xPagos, yPagos += 4 );
                doc.text('Fecha Final:' , xPagos, yPagos += 4 );
                doc.text('Fecha de Pago:' , xPagos, yPagos += 4 );
                doc.text('Num Días:' , xPagos, yPagos += 4 );
                if(ObjNom.nomina.receptor.tipoJornada){
                    if(ObjNom.nomina.receptor.tipoJornada.tipoJornada){
                        doc.text('Tipo Jornada:' , xPagos, yPagos += 4 );
                    }
                }
                doc.text('Total Percepciones:' , xPagos, yPagos += 4 );
                doc.text('Total Deducciones:' , xPagos, yPagos += 4 );
                doc.text('Total Otros Pagos:' , xPagos, yPagos += 4 );
                if(ObjTrabajador.tipoRegimen.clave === '02'){
                    doc.text('Salario Base Cot Apor:' , xPagos, yPagos += 4 );
                    doc.text('S.D.I.:' , xPagos, yPagos += 4 );
                }

                doc.setFont('helvetica', 'normal');
                doc.text(ObjNom.nomina.tipoNomina.tipoNomina, xxPagos, yyPagos += 6 );
                doc.text(this.formatDate(ObjNom.nomina.fechaInicialPago), xxPagos, yyPagos += 4 );
                doc.text(this.formatDate(ObjNom.nomina.fechaFinalPago), xxPagos, yyPagos += 4 );
                doc.text(this.formatDate(ObjNom.nomina.fechaPago), xxPagos, yyPagos += 4 );
                doc.text(this.formatCantidad(ObjNom.nomina.numDiasPagados), xxPagos, yyPagos += 4 );
                console.log(ObjNom.nomina.receptor.tipoJornada)
                if(ObjNom.nomina.receptor.tipoJornada){
                    if(ObjNom.nomina.receptor.tipoJornada.tipoJornada){
                        doc.text(ObjNom.nomina.receptor.tipoJornada.tipoJornada, xxPagos, yyPagos += 4 );
                    }
                }
                doc.text(this.formatCurrency(ObjNom.nomina.totalPercepciones), xxPagos, yyPagos += 4 );
                doc.text(this.formatCurrency(ObjNom.nomina.totalDeducciones), xxPagos, yyPagos += 4 );
                doc.text(this.formatCurrency(ObjNom.nomina.totalOtrosPagos), xxPagos, yyPagos += 4 );
                if(ObjTrabajador.tipoRegimen.clave === '02'){
                    doc.text(this.formatCurrency(ObjNom.nomina.receptor.salarioBaseCotApor), xxPagos, yyPagos += 4 );
                    doc.text(this.formatCurrency(ObjNom.nomina.receptor.salarioDiarioIntegrado), xxPagos, yyPagos += 4 );
                }

                //APARTADO DE CONCEPTOS
                // let yConceptos = yyPagos + 4
                let yConceptos = yTrabajador + 4
                if(yyPagos > yTrabajador){
                    yConceptos = yyPagos+4
                }
                let yyConceptos = yyPagos + 4
                doc.setFillColor(color_);
                doc.setDrawColor(color_);
                doc.roundedRect(10, yConceptos, 190, 5, 2, 2, 'FD');
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(12);
                doc.setTextColor(255, 255, 255); // Blanco
                doc.text('CONCEPTOS' , 100, yConceptos += 4, { align: 'center' } );

                //INICIA LA TABLA QUE SE DIBUJA CON UN FOR Y LOS REGISTROS
                //PRIMERO LA CABACERA
                doc.setTextColor(0, 0, 0); // NEGRO
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(10);
                let xDescripcion = 10;
                let xCantidad = 115;
                let xClaveUnidad = 140;
                let xValorUnitario = 175;
                let xImporte = 200;
                yConceptos += 5

                doc.text('Descripción' , xDescripcion, yConceptos, { align: 'left' } );
                doc.text('Cantidad' , xCantidad, yConceptos, { align: 'center' } );
                doc.text('Clave Unidad' , xClaveUnidad, yConceptos, { align: 'center' } );
                doc.text('Valor Unitario' , xValorUnitario, yConceptos, { align: 'right' } );
                doc.text('Importe' , xImporte, yConceptos, { align: 'right' } );
                doc.line(xDescripcion, yConceptos += 1, xImporte, yConceptos + 1);
                //RECORREMOS LA LISTA DE CONCEPTOS Y CREAMOS LA TABLA MANUALMENTE
                yyConceptos = yConceptos + 7;
                for(let c_ of ObjNom.conceptos){
                    doc.setFont('helvetica', 'bold');
                    doc.text(c_.descripcion , xDescripcion, yConceptos += 4, { align: 'left' } );
                    doc.setFont('helvetica', 'normal');
                    doc.text(this.formatCantidad(c_.cantidad) , xCantidad, yyConceptos, { align: 'center' } );
                    doc.text(c_.claveUnidad.claveUnidad , xClaveUnidad, yyConceptos, { align: 'center' } );
                    doc.text(this.formatCurrency(c_.valorUnitario) , xValorUnitario, yyConceptos, { align: 'right' } );
                    doc.text(this.formatCurrency(c_.importe) , xImporte, yyConceptos, { align: 'right' } );

                    let claveProdServ = doc.splitTextToSize(c_.claveProdServ.claveProdServ, 105)
                    let claveProdServHeight = doc.getTextDimensions(claveProdServ).h;
                    doc.text(claveProdServ , xDescripcion, yConceptos += 4, { align: 'left' } );
                    yConceptos += claveProdServHeight -1
                    doc.line(xDescripcion, yConceptos, xImporte, yConceptos);
                    yyConceptos += 4
                }

                //PERCEPRIONES
                let yPercepciones = yConceptos += 4
                if(ObjNom.nomina.percepciones.percepciones.count != 0){
                    let yyPercepciones = yPercepciones
                    doc.setFillColor(color_);
                    doc.setDrawColor(color_);
                    doc.roundedRect(10, yConceptos, 190, 5, 2, 2, 'FD');
                    doc.setFont('helvetica', 'bold');
                    doc.setFontSize(12);
                    doc.setTextColor(255, 255, 255); // Blanco
                    doc.text('PERCEPCIONES' , 100, yConceptos += 4, { align: 'center' } );

                    //INICIA LA TABLA QUE SE DIBUJA CON UN FOR Y LOS REGISTROS
                    //PRIMERO LA CABACERA
                    doc.setTextColor(0, 0, 0); // NEGRO
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(10);
                    let xClaveP = 10;
                    let xDescripcionP = 30;
                    let xGravadoP = 150;
                    let xExentoP = 200;
                    yPercepciones += 9

                    doc.text('Clave' , xClaveP, yPercepciones, { align: 'left' } );
                    doc.text('Concepto' , xDescripcionP, yPercepciones, { align: 'left' } );
                    doc.text('Importe Gravado' , xGravadoP, yPercepciones, { align: 'right' } );
                    doc.text('Importe Exento' , xExentoP, yPercepciones, { align: 'right' } );
                    doc.line(xClaveP, yPercepciones += 1, xExentoP, yPercepciones + 1);

                    //RECORREMOS LA TABLA DE PERCEPCIONES PARA MOSTRARLOS EN PANTALLA
                    yyPercepciones += 10
                    for(let p_ of ObjNom.nomina.percepciones.percepciones){
                        doc.setFont('helvetica', 'bold');
                        doc.text(p_.concepto , xDescripcionP, yPercepciones += 4, { align: 'left' } );
                        doc.setFont('helvetica', 'normal');
                        doc.text(p_.tipoPercepcion.tipoPercepcion , xDescripcionP, yPercepciones += 4, { align: 'left' } );
                        doc.text(p_.clave , xClaveP, yyPercepciones += 6, { align: 'left' } );
                        doc.text(this.formatCurrency(p_.importeGravado) , xGravadoP, yyPercepciones, { align: 'right' } );
                        doc.text(this.formatCurrency(p_.importeExento) , xExentoP, yyPercepciones, { align: 'right' } );
                        yPercepciones+=2
                        doc.line(xClaveP, yPercepciones, xExentoP, yPercepciones);
                        yyPercepciones += 4
                    }
                }

                // DEDUCCIONES
                let yDeducciones = yPercepciones += 4
                if(ObjNom.nomina.deducciones){
                    if(ObjNom.nomina.deducciones.deducciones.count != 0){
                        let yyDeducciones = yDeducciones
                        doc.setFillColor(color_);
                        doc.setDrawColor(color_);
                        doc.roundedRect(10, yDeducciones, 190, 5, 2, 2, 'FD');
                        doc.setFont('helvetica', 'bold');
                        doc.setFontSize(12);
                        doc.setTextColor(255, 255, 255); // Blanco
                        doc.text('DEDUCCIONES' , 100, yDeducciones += 4, { align: 'center' } );
    
                        //INICIA LA TABLA QUE SE DIBUJA CON UN FOR Y LOS REGISTROS
                        //PRIMERO LA CABACERA
                        doc.setTextColor(0, 0, 0); // NEGRO
                        doc.setFont('helvetica', 'normal');
                        doc.setFontSize(10);
                        let xClaveD = 10;
                        let xDescripcionD = 30;
                        let xImporteD = 200;
                        yDeducciones += 5
    
                        doc.text('Clave' , xClaveD, yDeducciones, { align: 'left' } );
                        doc.text('Concepto' , xDescripcionD, yDeducciones, { align: 'left' } );
                        doc.text('Importe' , xImporteD, yDeducciones, { align: 'right' } );
                        doc.line(xClaveD, yDeducciones += 1, xImporteD, yDeducciones + 1);
                        yyDeducciones += 10;
    
                        //CREAMOS LOS REGISTROS
                        for(let d_ of ObjNom.nomina.deducciones.deducciones){
                            doc.setFont('helvetica', 'bold');
                            let cDeduccion = doc.splitTextToSize(d_.concepto, 120);
                            let cDeduccion_Height = doc.getTextDimensions(cDeduccion).h;

                            doc.text(cDeduccion , xDescripcionD, yDeducciones += 4, { align: 'left' } );

                            doc.setFont('helvetica', 'normal');
                            doc.text(d_.tipoDeduccion.tipoDeduccion , xDescripcionD, yDeducciones += cDeduccion_Height, { align: 'left' } );
                            doc.text(d_.clave , xClaveD, yyDeducciones += 6, { align: 'left' } );
                            doc.text(this.formatCurrency(d_.importe) , xImporteD, yyDeducciones, { align: 'right' } );
                            yDeducciones+=2
                            doc.line(xClaveD, yDeducciones, xImporteD, yDeducciones);
                            yyDeducciones += 4
                        }
                    }
                }

                //OTROS PAGOS
                let yOtros = yDeducciones += 4
                if(ObjNom.nomina.otrosPagos){
                    if(ObjNom.nomina.otrosPagos.otroPagos.count != 0){
                        let yyOtros = yOtros
                        doc.setFillColor(color_);
                        doc.setDrawColor(color_);
                        doc.roundedRect(10, yOtros, 190, 5, 2, 2, 'FD');
                        doc.setFont('helvetica', 'bold');
                        doc.setFontSize(12);
                        doc.setTextColor(255, 255, 255); // Blanco
                        doc.text('OTROS PAGOS' , 100, yOtros += 4, { align: 'center' } );
    
                        //INICIA LA TABLA QUE SE DIBUJA CON UN FOR Y LOS REGISTROS
                        //PRIMERO LA CABACERA
                        doc.setTextColor(0, 0, 0); // NEGRO
                        doc.setFont('helvetica', 'normal');
                        doc.setFontSize(10);
                        let xClaveO = 10;
                        let xDescripcionO = 30;
                        let xImporteO = 200;
                        yOtros += 5
    
                        doc.text('Clave' , xClaveO, yOtros, { align: 'left' } );
                        doc.text('Concepto' , xDescripcionO, yOtros, { align: 'left' } );
                        doc.text('Importe' , xImporteO, yOtros, { align: 'right' } );
                        doc.line(xClaveO, yOtros += 1, xImporteO, yOtros + 1);
                        yyOtros += 10;
    
                        //CREAMOS LOS REGISTROS
                        for(let o_ of ObjNom.nomina.otrosPagos.otroPagos){
                            doc.setFont('helvetica', 'bold');
                            doc.text(o_.concepto , xDescripcionO, yOtros += 4, { align: 'left' } );
                            doc.setFont('helvetica', 'normal');
                            let otroP = doc.splitTextToSize(o_.tipoOtroPago.tipoOtroPago, 120);
                            let otroP_Height = doc.getTextDimensions(otroP).h;
                            doc.text(otroP , xDescripcionO, yOtros += 4, { align: 'left' } );
                            doc.text(o_.clave , xClaveO, yyOtros += 6, { align: 'left' } );
                            doc.text(this.formatCurrency(o_.importe) , xImporteO, yyOtros, { align: 'right' } );
                            yOtros += otroP_Height
                            doc.line(xClaveO, yOtros, xImporteO, yOtros);
                            yyOtros += 4
    
                            //INSERTMOS EL SALTO DE PAGINA
                            let espacioDisponible = doc.internal.pageSize.height - 40;
                            let dif = yOtros > espacioDisponible
                            if (dif) {
                                doc.addPage();
                                yOtros = 10;
                                yyOtros = 10;
                            } else {
                                yOtros += otroP_Height
                                // doc.line(xClaveO, yOtros, 200, yOtros);
                                yOtros += 4;
                            }
                        }
                    }
    
                    let espacioDisponibleL = doc.internal.pageSize.height - 50;
                    let difL = yOtros > espacioDisponibleL
                    if (difL) {
                        yOtros = 10
                        doc.addPage();
                    }
                }

                //APARTADO DEL IMPORTE CON LETRA
                let xImporteLetra = 10
                let yImporteLetra = yOtros
                let yyImporteLetra = yOtros
                const func = require('../../../plugins/numeroALetras.js')
                let importeLetra = func.numeroALetras(ObjNom.total, 'MXN');
                
                yImporteLetra += 5
                doc.setFontSize(9);
                doc.setFont('helvetica', 'bold');
                doc.text('Importe con Letra: ' , xImporteLetra, yImporteLetra, { align: 'left' } );
                doc.setFont('helvetica', 'normal');         
                doc.text(importeLetra, xImporteLetra + 5, yyImporteLetra += 9, { align: 'left' } );

                //APARTADO DE IMPORTES
                let ArrayImportes = []
                let ObjSubTotal = {descripcion: 'SubTotal:', importe: this.formatCurrency(ObjNom.subTotal)}
                let ObjDescuento = {descripcion: 'Descuento:', importe: this.formatCurrency(ObjNom.descuento)}
                let ObjTotal = {descripcion: 'Total:', importe: this.formatCurrency(ObjNom.total)}
                let xImportes = 150
                let xxImportes = 200;
                ArrayImportes.push(ObjSubTotal);
                ArrayImportes.push(ObjDescuento);
                ArrayImportes.push(ObjTotal);
                //CREAMOS LOS REGISTROS
                for(let imp_ of ArrayImportes){
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(12);
                    if(imp_.descripcion === 'Total:'){
                        doc.setFont('helvetica', 'bold');
                    }
                    doc.text(imp_.descripcion , xImportes, yImporteLetra, { align: 'left' } );
                    doc.text(imp_.importe , xxImportes, yImporteLetra, { align: 'right' } );
                    yOtros+=2
                    yImporteLetra +=1
                    doc.line(xImportes, yImporteLetra + 1, xxImportes, yImporteLetra + 1);
                    yImporteLetra += 6
                }

                //DATOS FISCALES
                doc.setFontSize(9);
                let yCertificados = yyImporteLetra + 6;
                let xCertificado = 45;
                doc.text('Fecha de Timbrado: ',xImporteLetra, yyImporteLetra += 6);
                doc.text('No. Certificado: ',xImporteLetra, yyImporteLetra += 4);
                doc.text('No. Certificado SAT: ',xImporteLetra, yyImporteLetra += 4);
                doc.text('Folio FIscal: ',xImporteLetra, yyImporteLetra += 4);

                doc.setFont('helvetica', 'normal');
                doc.text(ObjNom.timbreFiscalDigital.fechaTimbrado, xCertificado, yCertificados) ;
                doc.text(ObjNom.timbreFiscalDigital.noCertificado, xCertificado, yCertificados += 4) ;
                doc.text(ObjNom.timbreFiscalDigital.noCertificadoSAT, xCertificado, yCertificados += 4) ;
                doc.text(ObjNom.timbreFiscalDigital.folioFiscal, xCertificado, yCertificados += 4) ;

                //APARTADO DE LA FIRMA
                let yFirma = 0;
                let xFirma = 100
                if(yCertificados >= yImporteLetra){
                    yFirma = yCertificados += 6
                }else{
                    yFirma = yImporteLetra += 6
                }
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(12);
                doc.setDrawColor('#000000');
                yFirma+=10
                doc.line(40, yFirma, 160, yFirma);
                doc.text(ObjNom.cliente.nombre, xFirma, yFirma += 6, { align: 'center' }) ;

                //OTRO SALTO DE LINEA
                
                let xSellos = 54
                let ySellos = yFirma + 10
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(6);

                let selloCfdi_ = doc.splitTextToSize(ObjNom.timbreFiscalDigital.selloCFDI.base64, 145);
                let selloCfdi_Height = doc.getTextDimensions(selloCfdi_).h;
                let selloSat_ = doc.splitTextToSize(ObjNom.timbreFiscalDigital.selloSAT.base64, 145);
                let selloSat_Height = doc.getTextDimensions(selloSat_).h;
                let cadenaOriginal = doc.splitTextToSize(ObjNom.timbreFiscalDigital.cadenaOriginal, 145);
                let cadenaOriginal_Height = doc.getTextDimensions(selloSat_Height).h;

                //INSERTMOS EL SALTO DE PAGINA
                // let posActual = doc.internal.getVerticalCoordinateString(doc.internal.getNumberOfPages()) > (pageSize.height - pageMargins.bottom +20)
                // if (!posActual) {
                //     doc.addPage();
                // }
                let espacioDisponible = doc.internal.pageSize.height - 50;
                let dif = ySellos > espacioDisponible
                if (dif) {
                    ySellos = 10
                    doc.addPage();
                }

                let yQr = ySellos;
                doc.setFont('helvetica', 'bold');
                doc.text('Sello CFDI: ', xSellos, ySellos)
                doc.text('Sello SAT: ', xSellos, ySellos + selloCfdi_Height +3)
                doc.text('Cadena Original: ', xSellos, ySellos + selloCfdi_Height + selloSat_Height + 6)

                doc.setFont('helvetica', 'normal');
                doc.text(selloCfdi_, xSellos, ySellos += 3) ;
                doc.text(selloSat_, xSellos, ySellos += selloCfdi_Height +=3) ;
                doc.text(cadenaOriginal, xSellos, ySellos += selloSat_Height +=3) ;

                //INSERTAMOS EL QR
                let ObjQr = ObjNom.timbreFiscalDigital.archioQr
                doc.addImage(ObjQr, 'PNG', 10, yQr, 40, 40);

                //AGREGAMOS EL PIE DE PAGINA
                var footerText = "Representación impresa de un CFDI";
                var totalPages = doc.internal.getNumberOfPages();
                for (var i = 1; i <= totalPages; i++) {
                    doc.setPage(i);
                    // Establecer la fuente y el estilo del pie de página
                    doc.setFont("helvetica", "italic");
                    doc.setFontSize(10);
                    doc.setTextColor(150);

                    // Agregar el contenido del pie de página
                    doc.text(footerText, doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 10, { align: 'center' });
                    doc.text('Documento generado por ContaGo', 10, doc.internal.pageSize.getHeight() - 10, { align: 'left' });
                    doc.text('Página ' + i + ' de ' + totalPages, 200, doc.internal.pageSize.getHeight() - 10, { align: 'right' });
                }

                // Guardar el archivo PDF
                let nombreArchivo = ObjNom.serie + '_' +ObjNom.folio + '_' +ObjNom.rfc + '_' + ObjNom.folioFiscal
                if(exporta === 'SI'){
                    doc.save(nombreArchivo + '.pdf');
                    this.loading = false;
                    this.$toast.add({severity:'success', summary: 'OK', detail:'Comprobante descargado con éxito, puede encontrar en archivo en su carpeta de descargas', life: 3000});
                }

                if(exporta === 'ZIP'){
                    let ObjXml = ObjNom.timbreFiscalDigital.archivoXml
                    let pdfBase64 = doc.output('datauristring');
                    let ObjPdf = pdfBase64.split(',')[1]
                    // console.log(ObjPdf)
                    console.log('Vamos a descargar')
                    this.DownloadZip(ObjPdf, ObjXml, nombreArchivo)
                    this.loading = false;
                    this.$toast.add({severity:'success', summary: 'OK', detail:'Comprobante descargado con éxito, puede encontrar en archivo en su carpeta de descargas', life: 3000});
                }

                if(exporta === 'MASIVO'){
                    let ObjXml = ObjNom.timbreFiscalDigital.archivoXml
                    let pdfBase64 = doc.output('datauristring');
                    let ObjPdf = pdfBase64.split(',')[1];
                    this.archivoPdf = ObjPdf;
                    this.archivoXml = ObjXml;
                }

                if(exporta === 'CORREO'){
                    let ObjXml = ObjNom.timbreFiscalDigital.archivoXml
                    let pdfBase64 = doc.output('datauristring');
                    let ObjPdf = pdfBase64.split(',')[1]
                    this.archivoPdf = ObjPdf;
                    this.archivoXml = ObjXml;
                }
            },

            DownloadZip(archivoPdf ,archivoXml, nombre){
                var zip = new JSZip();

                var archivo1 = this.b64toBlob(archivoXml, 'xml');
                var archivo2 = this.b64toBlob(archivoPdf, 'pdf');
                zip.file("Recibo de nómina/" + nombre + ".xml", archivo1);
                zip.file("Recibo de nómina/" + nombre + ".pdf", archivo2);

                zip.generateAsync({type:"blob"})
                .then(function(content) {
                    // Crea un objeto URL del archivo Blob
                    var url = URL.createObjectURL(content);
                    
                    // Crea un enlace de descarga
                    var link = document.createElement('a');
                    link.href = url;
                    link.download = nombre + ".zip";
                    document.body.appendChild(link);
                    
                    // Descarga el archivo
                    link.click();
                    
                    // Elimina el objeto URL
                    URL.revokeObjectURL(url);
                });
            },

            async DownloadSeleccionados(){
                if(this.selectedListNomina.length == 0){
                    this.$toast.add({severity:'warn', summary: 'Precaución', detail:'Seleccione al menos un trabajador para descargar', life: 3000});
                    return;
                }

                this.loading = true;
                this.loadingMensaje = 'Descargando comprobantes, espere';

                var zip = new JSZip();
                for(var x of this.selectedListNomina){
                    if(x.folioFiscal != ''){
                        this.archivoXml = '';
                        this.archivoPdf = '';
                        console.log(x.folioFiscal)
                        await this.VerPdfKit(x, 'MASIVO')
                        let archivoXml = this.archivoXml;
                        let archivoPdf = this.archivoPdf;
                        let nombre = x.serie + '_' +x.folio + '_' +x.rfc + '_' + x.folioFiscal

                        let archivo1 = this.b64toBlob(archivoXml, 'xml');
                        let archivo2 = this.b64toBlob(archivoPdf, 'pdf');
                        zip.file("Recibo de nómina/" + nombre + ".xml", archivo1);
                        zip.file("Recibo de nómina/" + nombre + ".pdf", archivo2);
                    }
                }
                let nombreArchivo = this.nomina.descripcion
                zip.generateAsync({type:"blob"})
                .then(function(content) {
                    var url = URL.createObjectURL(content);
                    var link = document.createElement('a');
                    link.href = url;
                    link.download =  nombreArchivo + ".zip";
                    document.body.appendChild(link);
                    link.click();
                    URL.revokeObjectURL(url);
                });

                this.loading = false;
                    this.$toast.add({severity:'success', summary: 'OK', detail:'Comprobantes descargados con éxito, puede encontrar el archivo en su carpeta de descargas', life: 3000});
            },

            OpenDialogCorreo(item){
                this.dialogCorreo = true;
                this.documentoCorreo = {...item}
                this.textoCorreo = 'Enviar comprobante';
                this.masivo = false;
            },

            OpenDialogCorreoM(){
                this.dialogCorreo = true;
                this.textoCorreo = 'Enviar comprobantes';
                this.masivo = true;
            },

            CloseDialogCorreo(){
                this.dialogCorreo = false;
            },
            
            async EnviaCorreo(){
                let item = { ...this.documentoCorreo }
                this.loading = true;
                this.loadingMensaje = 'Enviando comprobante, espere...'
                try{
                    this.archivoPdf = '';
                    this.archivoXml = '';
                    let indexCorreo = this.datosTrabajadores.findIndex(x => x.rfc === item.rfc)
                    let correo = this.datosTrabajadores[indexCorreo].correo
                    // let correo = 'erck410@gmail.com'
                    let nombre = item.cliente.nombre
                    let nombreArchivo = item.folioFiscal
                    await this.VerPdfKit(item, 'CORREO')
                    let ObjCorreo = {
                        asunto: this.correo.asunto,
                        mensaje: this.correo.mensaje,
                        emisor: {
                            correo: '',
                        },
                        receptores:[
                            {nombre: nombre, correo: correo}
                        ],
                        archivos: [
                            {base64: this.archivoPdf, nombre: nombreArchivo + '.pdf'},
                            {base64: this.archivoXml, nombre: nombreArchivo + '.xml'},
                        ]
                    }
                    console.log(ObjCorreo);
                    let response = await axios.post('Correos/PostCorreos/' + '/' + this.token.empresaBase + '/' +this.token.idusuariosApp, ObjCorreo);
                    console.log(response.data)
                    this.loading = false;
                    this.$toast.add({severity:'success', summary: 'OK', detail:'Correo enviado con éxito', life: 3000});
                }catch(error){
                    console.log(error)
                    this.loading = false;
                    this.$toast.add({severity:'error', summary: 'Error', detail:'Error al enviar, verifique que los datos sean correctos, o comuniquese con el equipo de ContaGo', life: 3000});
                }
            },

            async EnviaCorreoMasivo(){
                for(let item of this.selectedListNomina){
                    this.documentoCorreo = { ...item }
                    await this.EnviaCorreo()
                    this.documentoCorreo = {}
                }
            },

            b64toBlob(base64, tipo) {
                var binary = atob(base64);
                var length = binary.length;
                var buffer = new ArrayBuffer(length);
                var view = new Uint8Array(buffer);
                for (var i = 0; i < length; i++) {
                    view[i] = binary.charCodeAt(i);
                }
                return new Blob([buffer], {type: tipo});
            },

            closeDialogPdf() {
                this.dialogPdf = false;
                // this.$store.state.facturaStore.idFactura = -1;
            },
        
            formatDate(date) {
                moment.locale('es-mx')
                let fechaR = moment(date).format("DD-MMMM-yyyy");
                return fechaR;
            },

            formatCurrency(value) {
                // return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

            formatCantidad(value) {
                let val = (value / 1).toFixed(3)
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
        
            PruebaWA(){
                const token = 'EAABoP2qoZAjYBAK6UaICXRVUdYoXYPO7SxOEuCqO9FtrnGrzxeasbkoB1AhMMpenxiQnf1bqfoXeuNcF9mLBTUoCodrmpHZBFZCHR9q9UqpNEoABgBg558LgpABLOlJ3sJMkz2UYbBEpvKpzjsdvEu68R9Hr25DI9ZBjerGjYACvtLQPHsosZC3IZABtsLIuPZAIZBwH9x21ZCZA0M66DCCgWt';
                const phoneNumber = '101779865922383';

                const recipient = '522228074564';
                const message = 'mensaje demo';

                // Realiza una solicitud HTTP POST a la API de WhatsApp
                fetch(`https://api.chat-api.com/instance/${token}/sendMessage`, {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                    phone: recipient,
                    body: message,
                    }),
                })
                .then(response => response.json())
                .then(data => {
                    console.log(data); // Muestra la respuesta de la API en la consola
                })
                .catch(error => {
                    console.error('Error:', error);
                });
            },

        },
    }
    
</script>